<template>
    <VRadioGroup
        v-model="val"
        :label="label"
        :density="density"
        :messages="messages"
        :disabled="disabled"
        :readonly="readonly"
        :errorMessages="errorMessages"
        @input="onChange">
        <VRadio v-for="(item, index) in items" :key="index" :value="item.value">
            <template #label>
                <span class="radio-field">
                    <span class="radio-field-label">{{ item.label }}</span>
                    <span v-if="item.subLabel" class="radio-field-label-sub">
                        {{ item.subLabel }}

                        <span v-if="item.subLabelExtra" class="radio-field-label-extra">
                            {{ item.subLabelExtra }}
                        </span>
                    </span>
                </span>
            </template>
        </VRadio>
    </VRadioGroup>
</template>

<script lang="ts">
    import { t } from '@shared/helpers/translation';
    import { defineComponent, watch, ref, PropType } from 'vue';
    import { VRadioGroup, VRadio } from 'vuetify/components';
    import { RadioItem, Density } from './Radio.interfaces';

    export default defineComponent({
        name: 'Radio',
        methods: { t },
        components: { VRadioGroup, VRadio },
        emits: ['update:modelValue'],
        props: {
            modelValue: { type: [String, Number] as PropType<string | number> },
            items: { type: Array as PropType<RadioItem[]>, default: () => [] },
            label: String,
            disabled: { type: Boolean as PropType<boolean>, default: false },
            readonly: { type: Boolean as PropType<boolean>, default: false },
            messages: { type: Array as PropType<string[]> },
            errorMessages: {
                type: [Array, String] as PropType<string[] | string>,
            },
            density: { type: String as PropType<Density>, default: 'default' },
        },
        setup(props, { emit }) {
            const val = ref<string | number | undefined>(props.modelValue);

            watch(
                () => props.modelValue,
                (newValue) => {
                    val.value = newValue;
                }
            );

            const onChange = () => {
                emit('update:modelValue', val.value);
            };

            return {
                val,
                onChange,
            };
        },
    });
</script>

<style lang="scss" scoped>
    @forward './Radio.scss';
</style>
